import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CART_KEY = "cafexir-cart";
const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(CART_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify(items));
    } catch {}
  }, [items]);

  const value = useMemo(
    () => ({
      items,
      isOpen,
      openCart: () => setIsOpen(true),
      closeCart: () => setIsOpen(false),
      count: items.reduce((sum, i) => sum + i.qty, 0),
      addItem: (handle, qty = 1, grind = "whole") =>
        setItems((prev) => {
          const key = `${handle}:${grind}`;
          const existing = prev.find((i) => (i.key || i.handle) === key || (grind === "whole" && i.handle === handle && !i.grind));
          if (existing)
            return prev.map((i) => (i === existing ? { ...i, qty: i.qty + qty } : i));
          return [...prev, { key, handle, qty, grind }];
        }),
      setQty: (key, qty) =>
        setItems((prev) =>
          qty <= 0 ? prev.filter((i) => (i.key || i.handle) !== key) : prev.map((i) => ((i.key || i.handle) === key ? { ...i, qty } : i))
        ),
      removeItem: (key) => setItems((prev) => prev.filter((i) => (i.key || i.handle) !== key)),
      clearAfterOrder: () => setItems([]),
    }),
    [items, isOpen]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
